import React from 'react';
import { Wrapper, CurrencySign, Dollars, Cents } from './DollarAmount.styles';

export const DollarAmount = ({ value, testId, color }) => {
  const num = typeof value === 'string' ? parseFloat(value) : value;

  if (!isFinite(num)) {
    return null;
  }

  const dollarsStr = new Intl.NumberFormat('en', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(Math.floor(Math.abs(num)));

  const rawCents = Math.abs(num) % 1;
  const centsStr =
    rawCents > 0
      ? `.${Math.round(rawCents * 100)
          .toString()
          .padStart(2, '0')}`
      : '.00';

  return (
    <Wrapper color={color} data-testid={testId} data-hj-suppress>
      <CurrencySign>$</CurrencySign>
      <Dollars>{dollarsStr}</Dollars>
      <Cents>{centsStr}</Cents>
    </Wrapper>
  );
};
